// src/components/Navbar.jsx
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import "../styles/navbar.css";

// D logo icon
import DataApparatusLogo from "../icons/logos/logoNew.png";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 40) {
        document.querySelector(".navbar")?.classList.add("scrolled");
      } else {
        document.querySelector(".navbar")?.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navItems = [
    { label: "Home", to: "/" },
    { label: "Services", to: "/services" },
    {
      label: "Domain Expertise",
      to: "/domain-expertise",
      children: [
        {
          label: "Overview",
          to: "/domain-expertise",
          description: "How domain context shapes the data platform work.",
          featured: true,
        },
        {
          label: "Financial Services",
          to: "/domain-expertise/financial-services",
          description: "Core banking, origination, payments and lending lifecycle data.",
        },
        {
          label: "Sustainability Reporting",
          to: "/domain-expertise/sustainability-reporting",
          description: "NGER, NPI, Scope 1, Scope 2 and Scope 3 reporting foundations.",
        },
        {
          label: "Industrial Operations",
          to: "/domain-expertise/construction",
          description: "Construction, quarry, mining, logistics and field operations data.",
        },
        {
          label: "Energy",
          to: "/domain-expertise/energy",
          description: "Meter, billing, asset, emissions and operational energy data.",
        },
      ],
    },
    { label: "Integrations", to: "/integrations" },
    { label: "Blog", to: "/blog" },
  ];

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <span className="navbar-logo-combo">
            <span className="navbar-logo-icon">
              <img
                src={DataApparatusLogo}
                className="navbar-logo-img"
                alt="Data Apparatus"
              />
            </span>
          </span>
        </Link>

        <ul className="navbar-desktop-menu">
          {navItems.map((item) => (
            <li
              key={item.label}
              className={`navbar-menu-item${item.children ? " has-dropdown" : ""}`}
            >
              <NavLink to={item.to}>{item.label}</NavLink>
              {item.children && (
                <div className="navbar-dropdown" aria-label={`${item.label} pages`}>
                  {item.children.map((child) => (
                    <NavLink
                      to={child.to}
                      key={child.label}
                      className={`navbar-dropdown-link${child.featured ? " overview" : ""}`}
                    >
                      <span>{child.label}</span>
                      {child.description && <small>{child.description}</small>}
                    </NavLink>
                  ))}
                </div>
              )}
            </li>
          ))}
        </ul>

        <Link to="/contact" className="navbar-reach-out-btn">
          Book Data Review
        </Link>

        <button
          onClick={() => setIsMenuOpen((open) => !open)}
          className="navbar-mobile-toggle"
          aria-label="Toggle menu"
        >
          {isMenuOpen ? "✕" : "☰"}
        </button>
      </div>

      <div className={`navbar-mobile-menu ${isMenuOpen ? "active" : ""}`}>
        {navItems.map((item) => (
          <React.Fragment key={item.label}>
            <NavLink
              to={item.to}
              className="navbar-mobile-item"
              onClick={() => setIsMenuOpen(false)}
            >
              {item.label}
            </NavLink>
            {item.children
              ?.filter((child) => child.to !== item.to)
              .map((child) => (
                <NavLink
                  key={child.label}
                  to={child.to}
                  className="navbar-mobile-item child"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {child.label}
                </NavLink>
              ))}
          </React.Fragment>
        ))}

        <Link
          to="/contact"
          className="navbar-mobile-reach-out-btn"
          onClick={() => setIsMenuOpen(false)}
        >
          Book Data Review
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;
